import { alpha } from '@mui/material/styles';

const FIGMA_SHADOW = '2px 4px 4px 0px rgba(0, 0, 0, 0.15)';
const REFINED_DIVIDER = '1px solid rgba(0, 0, 0, 0.08)';
const BRAND_COLOR = '#4A3DFF';

// 1. SCROLLBAR DEFINITIONS
export const scrollbarStyle = {
  maxHeight: 200,
  overflowY: 'auto',
  '&::-webkit-scrollbar': { width: '6px' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(136, 136, 136, 0.5)',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(85, 85, 85, 0.6)' },
  '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(240, 240, 240, 0.7)' },
};

export const scrollbarStyle2 = {
  maxHeight: '70vh',
  overflowY: 'auto',
  '&::-webkit-scrollbar': { width: '6px' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(136, 136, 136, 0.5)',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(85, 85, 85, 0.6)' },
  '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(240, 240, 240, 0.7)' },
};

// 2. MAIN WORKSPACE OBJECT
export const styles = {
  columnLayout: {
    display: 'flex',
    height: '100vh',
    bgcolor: '#F8F9FA',
    overflow: 'hidden',
  },
  cardBase: {
    bgcolor: '#FFFFFF',
    border: REFINED_DIVIDER,
    boxShadow: FIGMA_SHADOW,
    borderRadius: '16px',
    p: 2,
  },
  actionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    bgcolor: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(10px)',
    borderBottom: REFINED_DIVIDER,
    padding: '10px 20px',
  },
  tagPillStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '16px',
    bgcolor: '#EEF0F2',
    px: 1.5,
    py: 0.2,
    minWidth: 'fit-content',
  },
  tagTextStyle: { fontSize: '0.75rem', fontWeight: 500, color: '#121212' },
  tagConnector: {
    width: '25px',
    height: '1.2px',
    bgcolor: 'rgba(0, 0, 0, 0.1)',
    mx: 0.5,
  },
  bubbleBase: {
    maxWidth: '75%',
    padding: '10px 16px',
    borderRadius: '13px',
    fontSize: '0.9rem',
    position: 'relative',
    boxShadow: '2px 4px 4px 0px rgba(0, 0, 0, 0.1)',
  },
  systemPill: {
    bgcolor: '#EEF0F2',
    color: '#637381',
    fontSize: '0.75rem',
    fontWeight: 700,
    padding: '6px 16px',
    borderRadius: '20px',
    textAlign: 'center',
    margin: '16px auto',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

// 3. LEGACY EXPORTS FOR INFO TAB / DELEGATION
export const appStyle = { display: 'flex', flexDirection: 'column', width: '100%' };
export const cardStyle = styles.cardBase;
export const thirdGridStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  width: '100%',
};
export const appOrderTimelineStyle = { ...styles.cardBase, mt: 2 };

export const secondTypographyStyle = { fontWeight: 700, mb: 1, color: '#121212' };
export const thirdTypographyStyle = { fontWeight: 500, color: 'text.secondary' };
export const forthTypographyStyle = { fontWeight: 600, color: 'text.primary' };

export const loadingButtonStyle = {
  bgcolor: BRAND_COLOR,
  color: '#FFF',
  fontWeight: 600,
  borderRadius: '12px',
  height: '48px',
  px: 4,
  boxShadow: '0px 8px 16px 0px rgba(74, 61, 255, 0.24)',
  textTransform: 'none',
  '&:hover': { bgcolor: '#1A1A1A', boxShadow: 'none' },
};

export const secondButtonStyle = {
  bgcolor: '#FFF',
  color: BRAND_COLOR,
  border: `1px solid ${BRAND_COLOR}`,
  fontWeight: 600,
  borderRadius: '12px',
  height: '48px',
  px: 4,
  textTransform: 'none',
  '&:hover': { bgcolor: alpha(BRAND_COLOR, 0.04) },
};

export const typographyContentStyle = {
  fontWeight: 500,
  fontSize: '0.875rem',
  color: 'text.secondary',
  mb: 1,
};

// 4. MODAL & ATTACHMENT COMPATIBILITY
export const cardTicketModalStyle = styles.cardBase;
export const listTicketModalStyle = { ...scrollbarStyle };
export const listItemTicketModalStyle = (selected, user) => ({
  '&:hover': { backgroundColor: '#F5F5F5' },
  backgroundColor: selected?.id === user?.id ? alpha(BRAND_COLOR, 0.1) : 'transparent',
  cursor: 'pointer',
});
